// Google Analytics utility functions
export const GA_TRACKING_ID = 'G-ZX2R2GDQKG';

// Initialize Google Analytics
export const initGA = () => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('config', GA_TRACKING_ID, {
      page_title: document.title,
      page_location: window.location.href,
    });
  }
};

// Track page views
export const pageview = (url) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('config', GA_TRACKING_ID, {
      page_path: url,
    });
  }
};

// Track custom events
export const event = ({ action, category, label, value }) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  }
};

// Track button clicks
export const trackButtonClick = (buttonName, location = '') => {
  event({
    action: 'click',
    category: 'button',
    label: `${buttonName}${location ? ` - ${location}` : ''}`,
  });
};

// Track form submissions
export const trackFormSubmission = (formName) => {
  event({
    action: 'submit',
    category: 'form',
    label: formName,
  });
};

// Track downloads
export const trackDownload = (fileName, fileType) => {
  event({
    action: 'download',
    category: 'file',
    label: `${fileName} (${fileType})`,
  });
};

// Track external links
export const trackExternalLink = (url, linkText) => {
  event({
    action: 'click',
    category: 'external_link',
    label: `${linkText} - ${url}`,
  });
};
